<template>
  <div></div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Awin',
  computed: {
    ...mapGetters({
      locale: 'locale',
    }),
  },
  data() {
    return {
      unsubscribe: function() {},
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'home') {
        this.$awin.setHome(this.locale)
      }
    },
  },
  created() {
    // if (this.$route.name === 'home') {
    //   this.$awin.setHome(this.locale)
    //   console.log('its home')
    // }

    //console.log('subscribing to mutations')
    this.unsubscribe = this.$store.subscribe(async (mutation, state) => {
      // if (mutation.type === 'PRODUCT_ADDED') {
      //   console.log(`Product added ${state}`, state)
      //   this.$awin.setCart(this.locale, state.cart.orderItems)
      // }
      // if (mutation.type === 'PRODUCT_REMOVED') {
      //   console.log(`Product removed ${state}`)
      //   this.$awin.setCart(this.locale, state.cart.orderItems)
      // }

      // if (mutation.type === 'LOCALE_CHANGED') {
      //   console.log(`Locale changed ${state}`)
      // }

      if (mutation.type === '$_search/PRODUCTS_UPDATED') {
        this.$awin.setSearch(state.$_search.products, state.$_search.text, this.locale)
      }

      if (mutation.type === '$_checkout/ORDER_CLOSED') {
        let totalCart = state.cart.orderItems.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0)

        await this.$awin.setConversionTag(state.cart.id, state.cart.token)
        // this.$awin.setConfirmation(this.locale, totalCart, state.cart.id, state.cart.currency, state.$_order.order.orderItems)
        this.$awin.setConfirmation(this.locale, totalCart, state.cart.id, state.cart.currency, state.cart.orderItems)

        this.$store.dispatch('clearCart')
      }

      if (mutation.type === '$_checkout/PAYMENT_CHECKOUT_STARTED') {
        this.$awin.setCart(this.locale, state.cart.orderItems)
      }

      if (mutation.type === '$_hotel/OFFER_LOADED') {
        this.$awin.setOffer(state.$_hotel.template, window.location.href, this.locale)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {},
}
</script>
